import RouteConfig from "@irati-web/app/src/routeConfig"

export const PERKS = "perks"
export const RECOGNITION = "recognition"
export const REWARD = "reward"
export const MEDICAL = "medical"
export const WALLET = "wallet"
export const PLATFORM = "platform"
export const ONBOARDING = "onboarding"
export const TOUR = "tour"
export const WELLNESS = "wellness"
export const ProductsRouteMap = {
  [RECOGNITION]: RouteConfig.RECOGNITION,
  [PERKS]: RouteConfig.PERKS,
  [REWARD]: RouteConfig.FLEXIREWARDS,
  [WALLET]: RouteConfig.WALLET,
  [MEDICAL]: RouteConfig.MEDICAL,
  [ONBOARDING]: RouteConfig.ONBOARDING,
  [WELLNESS]: RouteConfig.WELLNESS
}

export const getTrackingProductName = () => {
  const path = location.pathname
  const productFound = Object.entries(ProductsRouteMap).find(([_, productPath]) => path.startsWith(productPath))
  return productFound?.[0]
}
